import {
  Component,
  EventEmitter,
  Input,
  NgModule,
  Output,
  OnInit,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemButtonModule } from '../button/button.directive';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-system-input-file',
  templateUrl: './input-file.component.html',
  styleUrls: ['./input-file.component.scss'],
})
export class InputFileComponent implements OnInit, OnChanges {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @Output() file = new EventEmitter<File>();
  @Input() class = '';
  @Input({ required: true }) textAccept = '';
  @Input({ required: true }) accept = '';
  @Input() errorMsg = '';
  @Input() fileName = '';
  loading = false;
  constructor() {}
  ngOnChanges(changes: SimpleChanges): void {
    this.errorMsg = changes.errorMsg?.currentValue ?? this.errorMsg;
    this.fileName = changes.fileName?.currentValue ?? this.fileName;
  }

  ngOnInit(): void {
    const dropzone = document.getElementById('dropzone');
    dropzone?.addEventListener('dragover', e => {
      e.preventDefault();
      dropzone.classList.add('bg-system-100');
    });

    dropzone?.addEventListener('dragleave', e => {
      e.preventDefault();
      dropzone.classList.remove('bg-system-100');
    });

    dropzone?.addEventListener('drop', e => {
      e.preventDefault();
      dropzone.classList.remove('bg-system-100');
      const file = e.dataTransfer?.files[0];
      this.file.emit(file);
    });
  }

  openWindowFile() {
    document.getElementById('dropzone-file')?.click();
  }
  onFileSelected(event: any) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.file.emit(file);

      this.fileInput.nativeElement.value = '';
    }
  }
}

@NgModule({
  declarations: [InputFileComponent],
  exports: [InputFileComponent],
  imports: [SystemButtonModule, CommonModule, TranslateModule],
})
export class SystemInputFileModule {}
